<template>
  <div>订单预览</div>
</template>

<script>
import { getOrderList } from "@/api/order";

export default {
  name: "orderInfo",
  data() {
    return {
      id: 0,
      orderInfo: [],
      listLoading: false
    };
  },
  created() {
    this.getList();
  },
  onLoad(options) {
    const id = options.id;
    if (id && id !== "null") {
      this.id = id;
      this.getList();
    }
  },
  watch: {},
  methods: {
    getList() {
      const id = this.id;
      if (!id) {
        return;
      }
      this.listLoading = true;
      const params = {
        id
      };
      getOrderList(params)
        .then(response => {
          this.list = response.data || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.aa{
  display: inline-block;
}
</style>
